import $ from "jquery"
import React from "react"
import close_img from "../../assets/images/close_btn.svg"

const WelcomeGraphics = () => {

    const handleModalClose = () => {
        $("#welcomegraphicsmodal").modal("hide")
    }

    return(
    
        <div className="main_popup">
        <div id="welcomegraphicsmodal" className="modal fade welcome_pop_model" role="dialog">
            <div className="modal-dialog">

                <div className="modal-content p-0">
       
                <div className="modal-body">
                                <button type="button" className="close" id="closemodalbtn"  aria-label="Close" onClick={handleModalClose}>
                                    <span aria-hidden="true"><img src={close_img} alt="" /></span>
                                </button> 
                <div id="content_div">

                <img src="images/Welcome Graphic Placeholder.png" className="welcome_show_img" alt="" />

                </div>
                           
                    
                </div>
               
                </div>

            </div>
        </div>
        </div>       
    )

}



export default WelcomeGraphics